export default {
  name: 'DashboardView',
  data: () =>({
      entity_name: sessionStorage.getItem('entity_name'), 
      // 1. Hero/Header Data
      hero_title: "BEE Trust",
      hero_description: "Management Portal",
      
      // 2. Stats Grid Data (Matches the 4 top cards)
      stats: [
        {
          label: "Pending KYC Reviews",
          value: "5",
          subtext: "2 urgent",
          icon: "fas fa-clipboard-check",
          colorClass: "icon-yellow"
        },
        {
          label: "Upcoming Meetings",
          value: "3",
          subtext: "Next: 28 Jan",
          icon: "fas fa-calendar-alt",
          colorClass: "icon-blue"
        },
        {
          label: "Resolution Pending",
          value: "2",
          subtext: "Acknowledgement required",
          icon: "fas fa-exclamation-triangle",
          colorClass: "icon-orange"
        },
        {
          label: "Compliance Score",
          value: "92%",
          subtext: "Excellent standing",
          icon: "fas fa-shield-alt",
          colorClass: "icon-green"
        }
      ],
      // 3. GlobalTable Data (Recent Documents)
      table_headers: [
        { label: "Document Name", key: "name" },
        { label: "Category", key: "category" },
        { label: "Date", key: "date" },
        { label: "Actions", key: "actions" }
      ],
      table_safe_company_list: [
        { 
          id: 1, 
          name: "Trust Deed - Amended 2024", 
          category: "Legal", 
          date: "15 Jan 2024",
          icon: "far fa-file-pdf"
        },
        { 
          id: 2, 
          name: "Trustee Meeting Minutes - Q4", 
          category: "Governance", 
          date: "20 Dec 2024",
          icon: "far fa-file-alt"
        },
        { 
          id: 3, 
          name: "B-BBEE Certificate 2024", 
          category: "Verification", 
          date: "01 Mar 2024",
          icon: "far fa-file-certificate"
        }
      ],
      // 4. Upcoming Meetings Data
      meetings: [
        {
          id: 1,
          tag: "Trustee Meeting",
          title: "Q1 Trustee Review Meeting",
          date: "28 Jan 2025",
          time: "10:00 AM"
        },
        {
          id: 2,
          tag: "Annual General Meeting",
          title: "Annual General Meeting",
          date: "15 Feb 2025",
          time: "10:00 AM"
        },
        {
          id: 3,
          tag: "Special Meeting",
          title: "Special Resolution - Amendment",
          date: "22 Feb 2025",
          time: "10:00 AM"
        }
      ],
      // 5. Action Center Data
      actions: [
        { id: 1, title: "Review KYC: Thandi Ngcobo", type: "KYC", statusColor: "dot-orange" },
        { id: 2, title: "Acknowledge Resolution #2024-15", type: "Resolution", statusColor: "dot-green" },
        { id: 3, title: "RSVP: Q1 Trustee Meeting", type: "Meeting", statusColor: "dot-green" },
        { id: 4, title: "Review KYC: Bongani Zulu", type: "KYC", statusColor: "dot-orange" }
      ],
      // 6. Distribution Data (For reference if you want to make it dynamic)
      distribution_stats: null
    
  }),
  methods: {
    get_doc_color_class(category) {
        const map = {
        'Legal': 'bg-red-light',
        'Governance': 'bg-gray-light',
        'Verification': 'bg-orange-light',
        'Financial': 'bg-green-light'
        };
      return Reflect.get(map, category) || 'bg-gray-light';
    },
    // Methods for your table actions

    deactivate_company() {
      if(confirm("Are you sure you want to deactivate this client?")) {
        // Your logic here
      }
    }
  },
  computed: {
    // Helper to check for specific roles or states
    is_super_user() {
      return this.$store.state.user.is_superuser;
    }
  },
  mounted() {
    this.distribution_stats = {
        ytd_total: "R 7 050 000",
        growth: "+12.5%",
        next_amount: "R 2 600 000",
        next_date: "15 Mar 2025"
      }
  }
};